import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleBarChart } from '@carbon/charts-react';
import { useAllInventoryItems } from 'src/hooks/useInventoryItems';
import { useChartTheme } from './useChartTheme';

interface TopConsumedItemsProps {
  topConsumedItems: Array<{ itemId: string; quantity: number }>;
}

const TopConsumedItems = React.memo((props: TopConsumedItemsProps) => {
  const { t } = useTranslation('dashboard');
  const chartTheme = useChartTheme();
  const query = useAllInventoryItems();
  const itemNames =
    query?.data?.data?.reduce(
      (acc, item) => Object.assign(acc, { [item.id]: item.name }),
      {} as Record<string, string>
    ) || {};
  return (
    <div className="dashboard__stat_widget">
      <SimpleBarChart
        data={props.topConsumedItems.map((row) => ({
          group: itemNames[row.itemId] || row.itemId,
          value: row.quantity ?? 0,
        }))}
        options={{
          title: t('topConsumedItems'),
          axes: {
            left: { mapsTo: 'group', scaleType: 'labels' as any },
            bottom: { title: t('quantity'), mapsTo: 'value' },
          },
          height: '400px',
          theme: chartTheme,
        }}
      />
    </div>
  );
});

export default TopConsumedItems;
